module.exports = __webpack_public_path__ + "static/video-3da84e72a6ef976e64953592124df093.mp4";